import { REGULAR_COLLECTIONS, TIMING_COLLECTION } from 'constants/gcConstants';
import {
  G_TIMING_QUERY_KEY,
  M_SEARCH_TIMING_QUERY_KEY,
  M_TIMING_QUERY_KEY,
} from 'constants/queryKeys';
import { useCatalogueDropdown } from 'hooks/useCatalogueDropdown';
import { useMOrgId } from 'hooks/useMOrgId';
import { GTiming } from 'interfaces/IGlobalCatalogue';
import { MTiming } from 'interfaces/IMasterDb';
import { composeList } from 'utils/catalogueMergeUtils';

export const useTimingCatalogue = (gOrgId: string | null) => {
  const mOrgId = useMOrgId();

  return useCatalogueDropdown<GTiming, MTiming, GTiming>({
    gOrgId,
    mOrgId,
    gCollectionKey: TIMING_COLLECTION,
    mCollectionKey: TIMING_COLLECTION,
    gSearchCollectionName: REGULAR_COLLECTIONS.timing,
    gQueryKey: [G_TIMING_QUERY_KEY],
    mQueryKey: [M_TIMING_QUERY_KEY],
    searchQueryKey: [M_SEARCH_TIMING_QUERY_KEY],
    mergeItems: composeList<GTiming, MTiming>,
  });
};
